var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"4","pageType":"Pioneer","currentIndex":_vm.currentIndex,"section3ScrollTop":_vm.section3ScrollTop}}),_c('Sustainability',{on:{"current-index-change":_vm.handleCurrentIndexChange,"section-3-scroll-top-change":_vm.handleSection3ScrollTopChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }